var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation_-_Files",
    "data-name": "Navigation - Files",
    transform: "translate(19699 5512)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5301",
    "data-name": "Rectangle 5301",
    width: 24,
    height: 24,
    transform: "translate(-19699 -5512)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "files-svgrepo-com",
    transform: "translate(-19698 -5511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34166",
    "data-name": "Path 34166",
    d: "M14.926,2H8.492a1.5,1.5,0,0,0-1.026.466A1.5,1.5,0,0,0,7,3.492V15.427a1.6,1.6,0,0,0,1.492,1.492H17.63a1.6,1.6,0,0,0,1.492-1.492V6.2Z",
    transform: "translate(-0.27)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34167",
    "data-name": "Path 34167",
    d: "M3,7.6V19.535a1.5,1.5,0,0,0,.466,1.026,1.5,1.5,0,0,0,1.026.466H13.63",
    transform: "translate(0 -0.378)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34168",
    "data-name": "Path 34168",
    d: "M15,2V6.662h4.662",
    transform: "translate(-0.811)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavFiles);
export default __webpack_public_path__ + "static/media/navFiles.2017d6819892bd753f43b3607fb13f72.svg";
export { ForwardRef as ReactComponent };